import React, { useEffect, useState } from "react";
import { deleteProjectProgressWorkType } from "../../../../api/projectProgressApi";
import "./DeleteWorkTypeModal.css";

const DeleteWorkTypeModal = ({
  open,
  projectId,
  workType,
  sectionName,
  onClose,
  onDeleted,
}) => {
  const [deleting, setDeleting] = useState(false);
  const [error, setError] = useState("");
  const isMilestone = Boolean(workType?.is_milestone);

  useEffect(() => {
    if (!open) return;
    setDeleting(false);
    setError("");
  }, [open, workType?.id]);

  useEffect(() => {
    if (!open) return undefined;
    const onKeyDown = (e) => {
      if (e.key === "Escape" && !deleting) onClose();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [open, deleting, onClose]);

  if (!open || !workType) return null;

  const handleDelete = async () => {
    try {
      setDeleting(true);
      setError("");
      await deleteProjectProgressWorkType(projectId, workType.id);
      onDeleted?.(workType);
      onClose();
    } catch (e) {
      setError(
        e?.message ||
          (isMilestone ? "Не удалось удалить веху" : "Не удалось удалить вид работ"),
      );
    } finally {
      setDeleting(false);
    }
  };

  return (
    <>
      <div
        className="delete-wt-modal-backdrop"
        onClick={() => !deleting && onClose()}
      />
      <div
        className="delete-wt-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="delete-wt-modal-title"
      >
        <h2 id="delete-wt-modal-title" className="delete-wt-modal__title">
          {isMilestone ? "Удаление вехи" : "Удаление вида работ"}
        </h2>
        <p className="delete-wt-modal__text">
          {isMilestone
            ? `Вы уверены, что хотите удалить веху «${workType.name}» в разделе ${sectionName || "—"}?`
            : `Вы уверены, что хотите удалить вид работ «${workType.name}» в разделе ${sectionName || "—"}?`}
        </p>
        <p className="delete-wt-modal__warn">
          {isMilestone
            ? "Все данные этой вехи будут удалены без возможности восстановления."
            : "Все данные, введённые в этом виде работ, будут удалены без возможности восстановления. После удаления потребуется проверить удельные веса видов работ в разделе."}
        </p>
        {error && <p className="delete-wt-modal__error">{error}</p>}
        <div className="delete-wt-modal__actions">
          <button
            type="button"
            className="delete-wt-modal__btn delete-wt-modal__btn--cancel"
            onClick={onClose}
            disabled={deleting}
          >
            Отмена
          </button>
          <button
            type="button"
            className="delete-wt-modal__btn delete-wt-modal__btn--delete"
            onClick={handleDelete}
            disabled={deleting}
          >
            {deleting ? "Удаление..." : "Удалить"}
          </button>
        </div>
      </div>
    </>
  );
};

export default DeleteWorkTypeModal;
